"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationForLandingPage = void 0;
const type_graphql_1 = require("type-graphql");
let LocationForLandingPage = class LocationForLandingPage {
    _id;
    name;
    machineName;
    countryName;
};
exports.LocationForLandingPage = LocationForLandingPage;
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], LocationForLandingPage.prototype, "_id", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], LocationForLandingPage.prototype, "name", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], LocationForLandingPage.prototype, "machineName", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], LocationForLandingPage.prototype, "countryName", void 0);
exports.LocationForLandingPage = LocationForLandingPage = __decorate([
    (0, type_graphql_1.ObjectType)("LocationForLandingPage")
], LocationForLandingPage);
//# sourceMappingURL=LocationForLandingPage.js.map